const STORAGE_KEY = "tc_auth";

let authToken: string | null =
  typeof localStorage !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;

let onUnauthorized: (() => void) | null = null;

export function setToken(token: string | null): void {
  authToken = token;
  if (typeof localStorage !== "undefined") {
    if (token) localStorage.setItem(STORAGE_KEY, token);
    else localStorage.removeItem(STORAGE_KEY);
  }
}

export function getToken(): string | null {
  return authToken;
}

export function setUnauthorizedHandler(handler: () => void): void {
  onUnauthorized = handler;
}

export async function apiFetch(path: string, options: RequestInit = {}): Promise<Response> {
  const headers = new Headers(options.headers as HeadersInit | undefined);
  headers.set("Content-Type", "application/json");
  if (authToken) headers.set("Authorization", `Bearer ${authToken}`);
  const res = await fetch(`/api${path}`, { ...options, headers });
  if (res.status === 401) {
    setToken(null);
    onUnauthorized?.();
  }
  return res;
}
